export default run;

function run($bbug, FormDataStoreService, $rootScope, $sessionStorage, accessibility, responsive, $injector, BBModel) {
    'ngInject';

    [accessibility, responsive].forEach(service => service.initialise());

    $rootScope.$setIfUndefined = FormDataStoreService.setIfUndefined;

    if (!$rootScope.bb) {
        $rootScope.bb = {};
    }
    $rootScope.bb.api_url = $sessionStorage.getItem('host');

    if ($bbug.support.opacity === false) {
        document.createElement('header');
        document.createElement('nav');
        document.createElement('section');
        document.createElement('footer');
    }

    const models = [
        'Address',
        'Answer',
        'Affiliate',
        'BBCollection',
        'Basket',
        'BasketItem',
        'BookableItem',
        'BulkPurchase',
        'BusinessQuestion',
        'Category',
        'Client',
        'ClientDetails',
        'Clinic',
        'Company',
        'CompanySettings',
        'Day',
        'Deal',
        'ExternalPurchase',
        'Event',
        'EventChain',
        'EventGroup',
        'EventTicket',
        'EventSequence',
        'Image',
        'Item',
        'Items',
        'ItemDetails',
        'Login',
        'MembershipLevel',
        'OpeningHours',
        'PackageItem',
        'Pagination',
        'PaymentCallbacks',
        'Person',
        'PrePaidBooking',
        'Product',
        'PurchaseItem',
        'PurchaseTotal',
        'Question',
        'Reason',
        'Resource',
        'Service',
        'Slot',
        'Space',
        'SurveyQuestion',
        'TimeSlot'
    ];

    for (const model of models) {
        BBModel[model] = $injector.get(model + 'Model');
    }

    const purchaseModels = [
        'Booking',
        'CourseBooking',
        'Total'
    ];

    BBModel['Purchase'] = {};
    for (const model of purchaseModels) {
        BBModel['Purchase'][model] = $injector.get(`Purchase.${model}Model`);
    }
}


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/main.run.js